import { TableCell as MuiTableCell } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

import theme from '../theme';

const {
  colors: { borderColor, tableCellColor },
} = theme;

const TableCell = ({ children, className, ...props }) => {
  const { classes, cx } = useStyles(styles);

  return (
    <MuiTableCell

      className={cx(classes.tableCell, className)} {...props}>
      {children}
    </MuiTableCell>
  );
};

const styles = ({ fontSizes, shape: { borderRadius }, spacing }) => ({
  tableCell: {
    fontWeight: 400,
    fontSize: fontSizes(13),
    padding: spacing(1, 2),
  },
});

TableCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default TableCell;
